import _ from 'lodash'
import React from 'react'
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs'
import useStyles from './tabs-style'

const TabsComponent = (props) => {
  const {
    tabs = [],
  } = props
  const style = useStyles()

  if (_.isEmpty(tabs)) return null

  return (
    <Tabs className={style.container}>
      <TabList className={style.tabs}>
        {
          _.map(tabs, (tab) => (
            <Tab
              key={`tab_${tab.id}`}
              className={style.tab}
            >
              {tab.title}
            </Tab>
          ))
        }
      </TabList>
      {
        _.map(tabs, (tab) => (
          <TabPanel
            key={`tabPanel_${tab.id}`}
          >
            {tab.contentComponent}
          </TabPanel>
        ))
      }
    </Tabs>
  )
}

export default TabsComponent
